module.exports = __webpack_public_path__ + "static/media/far_planets.22ef1275.png";